import React from 'react';
import {Form, Input, Button, Typography, notification} from 'antd';
import '../../css/formMessage.css'
import {api} from "../../services";

const { Title } = Typography;

const FormMessage = ({ data }) => {

    const [form] = Form.useForm();
    const onFinish = async (values) => {
        const formattedMessage = data.inputShort.map(input => {
            return `${input.input}: ${values[`input-${input.id}`]}`;
        }).concat(data.inputLong.map(input => {
            return `${input.input}: ${values[`input-${input.id}`]}`;
        })).join('\n');  

        try {
            const response = await api.general.sendMail( {
                message: `${formattedMessage}` 
            
            });

            if (response.status === 200) {
                notification.success({
                    message: 'Success',
                    description: 'Email sent successfully!',
                    placement: 'top',
                    style: {
                        fontSize: '16px',
                    },
                });

                form.resetFields();
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Failed to send email.',
                    placement: 'top',
                    style: {
                        fontSize: '16px',
                    },
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Error sending email.',
                placement: 'top',
                style: {
                    fontSize: '16px',
                },
            });
        }
    };    
    return (
        <Form
            form={form}
            name="custom-form"
            layout="vertical"
            onFinish={onFinish}
            className= {"custom-form"}
        >
            <Title level={2} >{data.title}</Title>

            {data.inputShort?.map(input => (
                <Form.Item
                    key={input.id}
                    label={input.input}
                    name={`input-${input.id}`}
                    rules={[{ required: true, message: `${input.input} is required!` }]}
                >
                    <Input placeholder={input.input}  />
                </Form.Item>
            ))}

            {data.inputLong?.map(input => (
                <Form.Item
                    key={input.id}
                    label={input.input}
                    name={`input-${input.id}`}
                    rules={[{ required: true, message: `${input.input} is required!` }]}
                >
                    <Input.TextArea placeholder={input.input} rows={5} />
                </Form.Item>
            ))}

            <Form.Item >
                <Button type="primary" htmlType="submit" >
                    {data.customButtons.buttonName}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default FormMessage;
